<!--
Program: Pagination
Author: SDL
Description: Pagination Common Component
-->
<template>
    <ul class="pagination b-pagination pagination-md justify-content-center">
        <li class="page-item" :class="[{ disabled: currentPage === 1 }]">
            <a href="javascript:" class="first" @click.prevent="changePage(1)">≪</a>
        </li>
        <li class="page-item" :class="[{ disabled: currentPage <= 1 }]">
            <a
                href="javascript:"
                class="pre"
                @click.prevent="changePage(1 >= currentPage - 10 ? 1 : currentPage - 10)"
            >{{ config.prevText }}</a>
        </li>
        <li
            v-for="num in pages"
            class="page-item"
            :class="[{ active: num === currentPage }]"
            :key="num"
        >
            <a href="javascript:" @click.prevent="changePage(num)" class="page-link">{{ num }}</a>
        </li>
        <li class="page-item" :class="[{ disabled: currentPage > lastPage }]">
            <a
                href="javascript:"
                class="next"
                @click.prevent="changePage(currentPage > lastPage - 10 ? lastPage : currentPage + 10)"
            >{{ config.nextText }}</a>
        </li>
        <li class="page-item" :class="[{ disabled: currentPage === lastPage || lastPage === 0 }]">
            <a href="javascript:" class="last" @click.prevent="changePage(lastPage)">≫</a>
        </li>
    </ul>
</template>
<script>
import Vue  from 'vue';
export default {
    props: {
        currentPage: {
            required: false,
            type: Number,
        },
        totalRows: {
            required: false,
            type: Number,
        },
        perPage: {
            required: false,
            type: Number,
        },
        limit: {
            type: Number,
            default: 10,
        },
    },
    data() {
        return {
            config: { prevText: '<', nextText: '>' },
            curPage: 1,
        };
    },
    computed: {
        /**
         * param:
         * return:
         * exception:
         * Description : last page calculation
         */
        lastPage() {
            const total = this.totalRows / this.perPage;
            if (total < 1) return 1;

            if (total % 1 !== 0) return parseInt(total + 1, 10);

            return total;
        },
        /**
         * param:
         * return:
         * exception:
         * Description : page calculation to be shown
         */
        pages() {
            let from = Math.floor((this.currentPage - 1) / 10) * 10 + 1;
            let to = from + 9;
            if (to >= this.lastPage) to = this.lastPage;
            const arr = [];
            while (from <= to) {
                arr.push(from);
                from += 1;
            }
            if (this.totalRows === null) {
                arr.splice(0);
                arr.push(1);
            }
            return arr;
        },
    },
    methods: {
        /**
         * param:
         * return:
         * exception:
         * Description : Parents' change event call
         */
        changePage(page) {
            if(this.totalRows !== 0) {
                this.$emit('change', page);
            }
        },
    },
    created() {
        this.curPage = this.currentPage;
        Vue.$log.info('＃ Pagination.vue created.');
    },
    mounted() {
        Vue.$log.info('＃ Pagination.vue mounted.');
    },
    beforeDestroy() {
        Vue.$log.info('＃ Pagination.vue beforeDestroy.');
    }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/common/control/pagination/Pagination.vue